export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14665.d1c1668a.jpg";